/** Regex Common. */
export const REGEX_COMMON = {
  INSTANCE_NAME: /^\w+$/,
  EMAIL: /^([a-zA-Z\d_.+-]+)@([a-zA-Z\d.-]+)\.([a-zA-Z]{2,6})$/,
  URL: /^(https?:\/\/)?(www\.)?([a-zA-Z\d-]+)\.([a-zA-Z\d.-]+)(\/[a-zA-Z\d-._~:/?#[\]@!$&'()*+,;=]*)?$/,
  XML_TAG: /^(?!\d)[^!@#$%^&*()+\s]+$/,
} as const;

/** Regex Auth. */
export const REGEX_AUTH = {
  OTP_CODE: /^\d{6}$/,
};

/** Regex Tenant. */
export const REGEX_TENANT = {
  ID: /^[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?$/,
};
